module.exports = __webpack_public_path__ + "img/Trans-Poses_0003_Queenie_talking.e7e71158.png";